var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenoit3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 183 329",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fcdbbc;\n      }\n\n      .cls-2 {\n        fill: #3b271b;\n      }\n\n      .cls-3 {\n        fill: #4d3423;\n      }\n\n      .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\n        fill: none;\n      }\n\n      .cls-4, .cls-5, .cls-7 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-4, .cls-7, .cls-8 {\n        stroke: #000d19;\n        stroke-width: 2px;\n      }\n\n      .cls-9 {\n        fill: #414a4c;\n      }\n\n      .cls-10 {\n        fill: #eeb68c;\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-12 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        stroke: #507e8f;\n        stroke-width: 3px;\n      }\n\n      .cls-13 {\n        fill: #8cbab7;\n      }\n\n      .cls-14 {\n        fill: #e3af5b;\n      }\n\n      .cls-15 {\n        fill: #1b526d;\n      }\n\n      .cls-6 {\n        stroke: #eeb68c;\n        stroke-width: 3.17px;\n      }\n\n      .cls-6, .cls-7, .cls-8 {\n        stroke-linecap: round;\n      }\n\n      .cls-6, .cls-8 {\n        stroke-linejoin: round;\n      }\n\n      .cls-16 {\n        fill: #000d19;\n      }\n\n      .cls-17 {\n        fill: #f8c79d;\n      }\n\n      .cls-18 {\n        fill: #052b33;\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-20 {\n        fill: #154259;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M108.58,68.61h-18.85c-3.89,0-6.17,4.39-3.92,7.57l1.38,1.95c5.84,8.26,18.1,8.26,23.94,0l1.38-1.95c2.25-3.18-.03-7.57-3.92-7.57Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M147.74,68.61h-18.85c-3.89,0-6.17,4.39-3.92,7.57l1.38,1.95c5.84,8.26,18.1,8.26,23.94,0l1.38-1.95c2.25-3.18-.03-7.57-3.92-7.57Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 114,
    cy: 299,
    rx: 49,
    ry: 20
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 119.39,
    y: 143.47,
    width: 17.42,
    height: 53.56,
    rx: 8.71,
    ry: 8.71,
    transform: "translate(287.32 311.81) rotate(168.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M110.2,133.76h27.98v22.92c0,7.72-6.27,13.99-13.99,13.99h0c-7.72,0-13.99-6.27-13.99-13.99v-22.92h0Z",
    transform: "translate(276.01 276.87) rotate(168.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 139.02,
    y: 152.9,
    width: 17.42,
    height: 53.56,
    rx: 8.71,
    ry: 8.71,
    transform: "translate(239.74 -33.97) rotate(62.73)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.49,102.91h11.62v14.77c0,13.34-10.83,24.17-24.17,24.17h-10.06v-16.33c0-12.48,10.13-22.61,22.61-22.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.5,67.37h89.77v23.44c0,13.37-10.86,24.23-24.23,24.23h-41.3c-13.37,0-24.23-10.86-24.23-24.23v-23.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M98.33,264.28c-5.27,0-9.55-4.28-9.55-9.55v-46.75c0-5.27,4.28-9.55,9.55-9.55s9.55,4.28,9.55,9.55v46.75c0,5.27-4.28,9.55-9.55,9.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M88.78,301.48v-46.75c0-5.27,4.28-9.55,9.55-9.55s9.55,4.28,9.55,9.55v46.75h-19.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M93.2,296.55h31.18v13.28h-26.73c-4.89,0-8.86-3.97-8.86-8.86h0c0-2.44,1.98-4.42,4.42-4.42Z",
    transform: "translate(213.15 606.37) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M117.43,251.18c5.27,0,9.55-4.28,9.55-9.55v-46.75c0-5.27-4.28-9.55-9.55-9.55-5.27,0-9.55,4.28-9.55,9.55v46.75c0,5.27,4.28,9.55,9.55,9.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M126.98,288.38v-46.75c0-5.27-4.28-9.55-9.55-9.55-5.27,0-9.55,4.28-9.55,9.55v46.75s19.1,0,19.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M112.3,283.45h31.18v13.28h-26.73c-4.89,0-8.86-3.97-8.86-8.86h0c0-2.44,1.98-4.42,4.42-4.42Z",
    transform: "translate(251.35 580.18) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M99.52,133.19h16.72c11.05,0,20.03,8.97,20.03,20.03v58.61h-56.77v-58.61c0-11.05,8.97-20.03,20.03-20.03Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 147.22,
    cy: 80.34,
    r: 11.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 76.42,
    cy: 80.34,
    r: 11.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96.85,12.75h29.09c16.74,0,30.34,13.59,30.34,30.34v23.51c0,5.24-4.26,9.5-9.5,9.5h-70.76c-5.24,0-9.5-4.26-9.5-9.5v-23.51c0-16.74,13.59-30.34,30.34-30.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.89,28.55h33.66c11.13,0,20.16,9.03,20.16,20.16v49.36c0,18.28-14.84,33.12-33.12,33.12h-7.75c-18.28,0-33.12-14.84-33.12-33.12v-49.36c0-11.13,9.03-20.16,20.16-20.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.34,114.19h19.09v19.22c0,5.27-4.28,9.54-9.54,9.54h0c-5.27,0-9.54-4.28-9.54-9.54v-19.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M134.34,104.46c-5.71,5.71-14.97,5.71-20.68,0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M90.02,65.48h18.27c2.81,0,5.1,2.29,5.1,5.1v2.47h-28.47v-2.47c0-2.81,2.29-5.1,5.1-5.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M108.58,68.61h-18.85c-3.89,0-6.17,4.39-3.92,7.57l1.38,1.95c5.84,8.26,18.1,8.26,23.94,0l1.38-1.95c2.25-3.18-.03-7.57-3.92-7.57Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 96.72,
    y: 59.17,
    width: 13.79,
    height: 23.14,
    rx: 6.9,
    ry: 6.9,
    transform: "translate(207.24 141.48) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 94.85,
    y: 73.06,
    width: 5.93,
    height: 10.81,
    rx: 2.96,
    ry: 2.96,
    transform: "translate(195.63 156.92) rotate(180)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M129.17,65.48h18.27c2.81,0,5.1,2.29,5.1,5.1v2.47h-28.47v-2.47c0-2.81,2.29-5.1,5.1-5.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M147.74,68.61h-18.85c-3.89,0-6.17,4.39-3.92,7.57l1.38,1.95c5.84,8.26,18.1,8.26,23.94,0l1.38-1.95c2.25-3.18-.03-7.57-3.92-7.57Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 135.88,
    y: 59.17,
    width: 13.79,
    height: 23.14,
    rx: 6.9,
    ry: 6.9,
    transform: "translate(285.55 141.48) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 134,
    y: 73.06,
    width: 5.93,
    height: 10.81,
    rx: 2.96,
    ry: 2.96,
    transform: "translate(273.93 156.92) rotate(180)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M125.31,69.48c-.49-1.47-2.14-1.47-2.63,0-1.92,5.74-5.26,14.61-5.26,22.91,0,7.08,6.58,7.59,6.58,7.59,0,0,6.58-.51,6.58-7.59,0-8.3-3.34-17.17-5.26-22.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.22,119.04v7.61c0,7.33-5.95,13.28-13.28,13.28h-20.35c-7.33,0-13.28-5.95-13.28-13.28v-7.61c0-2.78,2.26-5.04,5.04-5.04h.88c1.77,0,3.21,1.44,3.21,3.21v4.91c0,2.67,2.17,4.84,4.84,4.84h18.97c2.67,0,4.84-2.17,4.84-4.84v-4.91c0-1.77,1.44-3.21,3.21-3.21h.88c2.78,0,5.04,2.26,5.04,5.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "130.31 150.14 107.73 173.09 116.49 175.9 104.55 197.54 130.31 173.15 121.07 169.34 130.31 150.14"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.52,73.26h20.47c1.94,0,3.52,1.58,3.52,3.52v4.44c0,2.93-2.38,5.31-5.31,5.31h-16.89c-2.93,0-5.31-2.38-5.31-5.31v-4.44c0-1.94,1.58-3.52,3.52-3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M92.87,73.26h20.47c1.94,0,3.52,1.58,3.52,3.52v4.44c0,2.93-2.38,5.31-5.31,5.31h-16.89c-2.93,0-5.31-2.38-5.31-5.31v-4.44c0-1.94,1.58-3.52,3.52-3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M116.85,80.17s2.21-3.47,7.08-3.47,7.08,3.47,7.08,3.47"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 158.51,
    y1: 77.91,
    x2: 162.04,
    y2: 77.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 85.95,
    y1: 77.91,
    x2: 89.35,
    y2: 77.91
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.45,118.42l-1.58,2.19c-.84,1.17-2.58,1.17-3.42,0l-1.58-2.19c-.85-1.17,0-2.81,1.44-2.81h3.71c1.45,0,2.29,1.64,1.44,2.81Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 108.04,
    y1: 211.83,
    x2: 108.04,
    y2: 293.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M135.33,54.7h16.64c2.38,0,4.31,1.93,4.31,4.31v.92c0,1.23-1,2.22-2.22,2.22h-20.81c-1.23,0-2.22-1-2.22-2.22v-.92c0-2.38,1.93-4.31,4.31-4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96.18,54.7h16.64c2.38,0,4.31,1.93,4.31,4.31v.92c0,1.23-1,2.22-2.22,2.22h-20.81c-1.23,0-2.22-1-2.22-2.22v-.92c0-2.38,1.93-4.31,4.31-4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123.57,27.83h18.88v3.43h-15.45c-1.89,0-3.43-1.54-3.43-3.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M91.81,27.83h32.62v3.43h-36.05c0-1.89,1.54-3.43,3.43-3.43Z",
    transform: "translate(212.81 59.08) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M26,73.41c12.35,7.6,24.03,16.15,35.51,24.98,11.48,8.84,22.64,18.11,33.6,27.69,10.96,9.57,21.88,19.2,33.17,28.3,11.27,9.14,22.77,17.94,35.24,25.37,2.5,1.49,3.32,4.73,1.83,7.23-1.49,2.5-4.73,3.32-7.23,1.83-.23-.14-.47-.31-.67-.47-11.17-9.27-23.32-17.16-35.69-24.72-12.36-7.59-25.08-14.67-37.77-21.79-12.69-7.12-25.17-14.54-37.33-22.4-12.16-7.87-24.13-16.01-35.42-25.11-5.52-4.45-6.39-12.53-1.94-18.05,4.1-5.09,11.29-6.22,16.72-2.88Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 163.42,
    cy: 186.13,
    rx: 9.95,
    ry: 6.3,
    transform: "translate(-82.89 212.25) rotate(-54.77)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 97.86,
    y: 154.78,
    width: 17.42,
    height: 53.56,
    rx: 8.71,
    ry: 8.71,
    transform: "translate(-97.17 128.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 116.28,
    y: 150.39,
    width: 17.42,
    height: 53.56,
    rx: 8.71,
    ry: 8.71,
    transform: "translate(188.33 384.53) rotate(-161.78)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 135.87,
    cy: 162.22,
    r: 14.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M93.71,149.87h0c7.72,0,13.99,6.27,13.99,13.99v22.92h-27.98v-22.92c0-7.72,6.27-13.99,13.99-13.99Z",
    transform: "translate(-91.58 115.56) rotate(-45)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 161.75,
    cy: 166.02,
    r: 14.42
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenoit3);
export default __webpack_public_path__ + "static/media/benoit_3.0ddfc83310da85d793a6dbac3c385a59.svg";
export { ForwardRef as ReactComponent };